<template>
  <div>
    <div class="row">
      <div class="col-12">
        <FullCalendar
          defaultView="dayGridWeek"
          height="auto"
          :showNonCurrentDates="false"
          :plugins="calendarPlugins"
          :header="{
            left: 'dayGridWeek,dayGridMonth',
            center: 'title',
            right: 'today prev,next'
          }"
          :buttonText="{
            'today': 'Today',
            'week': 'Week',
            'month': 'Month'
          }"
          :events="calendar_events"
          @eventClick="eventClick"
          @dateClick="dateClick"
          />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '../../../router'
import _ from 'lodash'

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '../../../assets/css/calendar.css'

export default {
  data: function () {
    return {
      loaded: false,
      calendarPlugins: [ dayGridPlugin, interactionPlugin ]
    }
  },
  computed: {
    ...mapGetters({
      calendar_events: 'allCalendarEvents',
      scoped_site_id: 'scopedSiteId',
      is_authenticated: 'isAuthenticated',
      site_of_ip: 'siteOfIp'
    })
  },
  components: {
    FullCalendar
  },
  watch: {
    scoped_site_id (newScopedSiteId, oldScopedSiteId) {
      this.loaded = false
      this.$store.dispatch('getCalendarEvents', new Date(0)).then(success => {
        this.loaded = true
      })
    },
    site_of_ip (newSite, oldSite) {
      if (_.isEmpty(oldSite) && oldSite !== newSite) {
        this.$store.dispatch('getCalendarEvents', new Date(0)).then(success => {
          this.loaded = true
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getCalendarEvents', new Date(0)).then(success => {
      this.loaded = true
    })
  },
  methods: {
    dateClick: function (info) {
      if (this.is_authenticated) {
        router.push({ name: 'DateOptions', params: { date: info.dateStr } })
      }
    },
    eventClick: function (info) {
      if (info.event.extendedProps.day_schedule_id) {
        this.$store.dispatch('changeSelectedDayScheduleId', info.event.extendedProps.day_schedule_id)

        if (this.is_authenticated) {
          router.push({ name: 'DayScheduler' })
        }
      }
    }
  }
}
</script>
